module.exports = __webpack_public_path__ + "img/Empty_Profile_Pic.3a491ad1.jpg";